<template>
  <div class="market-card-wrap">
    <div class="market-card-content">
      <ul class="market-card">
        <li v-for="(market, index) in getMarketHotListByCurrency" :key="index" v-if="market.status == 1">
          <router-link :to="`/exchange?pair=${market.symbol}`">
            <span>{{ market.pair }}</span>
            <span>{{ '0' == market.close || 0 == market.close ? '0.00' : !market.close ? '-' : market.close }}</span>
            <span> {{ $t('market.list.table.header.24HVol') }} {{ !market.volume ? '-' : market.volume }} </span>
            <template v-if="market.change">
              <span v-if="Number(market.change) === 0" class="color-white">{{ market.change }}%</span>
              <span v-if="Number(market.change) > 0" class="color-success">+{{ market.change }}%</span>
              <span v-if="Number(market.change) < 0" class="color-error">{{ market.change }}%</span>
            </template>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Banner',
  components: {},
  data() {
    return {
      markets: []
    };
  },
  computed: {
    ...mapGetters(['getMarketHotListByCurrency', 'Getter_Current_Currency'])
  },
  watch: {
    Getter_Current_Currency: function(val) {
      if (val) {
        this.alterMarketHotListByCurrency_action();
      }
    }
  },
  created() {
    this.getMarketHotList_action();
  },
  methods: {
    ...mapActions(['getMarketHotList_action', 'updateMarketHotList_action', 'alterMarketHotListByCurrency_action'])
  }
};
</script>

<style lang="stylus" scoped>
.market-card-wrap {
  margin: 0 auto;
  max-width: 1240px;
  display: flex;
  overflow-x: auto;

  .market-card-content {
    width: 1200px;

    .market-card {
      margin: 0 20px;
      padding: 20px 0;
      display: flex;
      width: 770px;

      > li {
        flex: 1 1 0px;
        margin: 0 5px;
        background-color: #111522;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        padding: 15px 18px;
        position: relative;
        background-size: cover;
        min-width: 250px;
        flex-wrap: wrap;

        > a {
          display: flex;
          flex-direction: column;
        }

        &:first-child {
          margin-left: 0;
        }

        &:last-child {
          margin-right: 0;
        }

        span {
          &:nth-child(1) {
            font-size: 12px;
            color: #fff;
          }

          &:nth-child(2) {
            color: #fff;
            font-size: 18px;
            font-weight: bold;
            line-height: 24px;
            padding-top: 10px;
            padding-bottom: 2px;
            color: rgba(255, 255, 255, 1);
          }

          &:nth-child(3) {
            color: #fff;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            padding-top: 4px;
            color: rgba(255, 255, 255, 1);
          }

          &:nth-child(4) {
            position: absolute;
            right: 18px;
            top: 15px;
            // color: #1dce8a;
            background: rgba(29, 206, 138, 0.2);
            padding: 0 4px;
            border-radius: 4px;
          }
        }

        span.color-white:nth-child(4) {
          background: rgba(242, 242, 242, 0.2);
          color: #ffffff;
        }

        span.color-error:nth-child(4) {
          background: rgba(219, 40, 40, 0.2);
          color: var(--error-text);
        }
      }
    }
  }
}
</style>
